/* eslint-disable prisma-rule/safe-local-storage */
import { useState, useEffect } from 'react';

function isNewDesignActive() {
  // during unit tests the old design is currently enforced
  // we should change this as soon as the feature toggle is public
  if (process.env.NODE_ENV === 'test') return false;
  return document.documentElement.getAttribute('data-theme') !== 'legacy';
}

export function useIsNewDesignActive() {
  const [active, setActive] = useState(isNewDesignActive());

  // listen for attribute changes
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'data-theme') {
          setActive(
            document.documentElement.getAttribute('data-theme') !== 'legacy'
          );
        }
      });
    });
    observer.observe(document.documentElement, { attributes: true });
    return () => observer.disconnect();
  }, []);

  return active;
}

export function toggleNewDesign() {
  if (isNewDesignActive()) {
    localStorage.removeItem('PRISMA_NEW_DESIGN');
    document.documentElement.setAttribute('data-theme', 'legacy');
  } else {
    localStorage.setItem('PRISMA_NEW_DESIGN', 'true');
    document.documentElement.removeAttribute('data-theme');
  }
  // locationReload();
}
